// extracted by mini-css-extract-plugin
module.exports = {"commonDynamicButton":"style_commonDynamicButton____evq","commonDynamicElement":"style_commonDynamicElement__bjbaZ"};